"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const apiUtils_1 = require("../../../util/apiUtils");
const auth_1 = require("../../../util/auth");
const common_styled_components_1 = require("../../common-styled-components");
const DownloadPDFButton = ({ fetchUrl, label, fileName, }) => {
    const { getAuthHeader, getAccessTokenSilently } = (0, auth_1.useAuthentication)();
    const handleDownload = async () => {
        try {
            const accessToken = await (0, auth_1.getAccessToken)(getAccessTokenSilently); // Fetch the token
            const authHeader = getAuthHeader(accessToken);
            const headersWithAuth = {
                "Content-Type": "application/pdf",
                ...authHeader,
            };
            const response = await fetch(`${(0, apiUtils_1.getAPIUrl)()}${fetchUrl}`, {
                method: "GET",
                headers: headersWithAuth,
            });
            if (!response.ok)
                throw new Error("Failed to fetch PDF");
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName; // Change filename as needed
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error("Error downloading PDF:", error);
        }
    };
    return (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: handleDownload, children: label });
};
exports.default = DownloadPDFButton;
